const API_URL = process.env.ZISK_API_URL;
const ADMIN_URL = API_URL.replace('/api/', '/admin/');

export const PATHS = {
    ads: {
        create: () => `${ADMIN_URL}ads`,
        get: () => `${ADMIN_URL}ads`,
        save: (id) => `${ADMIN_URL}ads/${id}`
    },
    aggregateData: {
        get: () => `${ADMIN_URL}stats/aggregate`,
        send: () => `${ADMIN_URL}reporting/aggregate_email`
    },
    auth: {
        login: () => `${API_URL}login`,
        resetPassword: () => `${API_URL}reset_password`
    },
    algorithm: {
        get: () => `${ADMIN_URL}config`,
        save: (id) => `${ADMIN_URL}config/${id}`
    },
    news: {
        getNewsStories: () => `${API_URL}blog/articles?page_size=30`
    },
    notifications: {
        cancel: (id) => `${ADMIN_URL}push_notifications/${id}`,
        get: (page, size, isSent) => `${ADMIN_URL}push_notifications?page=${page || 0}&page_size=${size || 20}${isSent ? '&sent=1' : ''}`,
        send: (type, id) => `${ADMIN_URL}push_notifications/${id || type}`
    },
    referralCodes: {
        get: (page) => `${ADMIN_URL}referral_code?page=${page || 0}&page_size=20`,
        create: () => `${ADMIN_URL}referral_code`,
        save: (id) => `${ADMIN_URL}referral_code/${id}`
    },
    prices: {
        get: () => `${ADMIN_URL}milk_announced_prices`,
        save: () => `${ADMIN_URL}milk_announced_prices`
    },
    user: {
        getMyProfile: () => `${API_URL}profile`
    },
    users: {
        get: (page, size, filterString) => `${ADMIN_URL}users?page=${page || 0}&pageSize=${size || 20}${filterString || ''}`,
        sendUsersCsv: () => `${ADMIN_URL}reporting/users_email`
    }
};



// WEBPACK FOOTER //
// ./src/utils/paths.js